<template>
  <div>
    <div class="lang-desktop d-flex justify-content-around local-changer">
      <div class="flag">
        <a @click.prevent="setLocale('ger')">
          <img src="../assets/ger.webp" height="20px" width="30px" />
        </a>
      </div>
      <div class="flag">
        <a @click.prevent="setLocale('en')">
          <img src="../assets/uk.webp" height="20px" width="30px" />
        </a>
      </div>
      <div class="flag">
        <a @click.prevent="setLocale('vn')">
          <img src="../assets/vn.webp" height="20px" width="30px" />
        </a>
      </div>
    </div>
    <div class="lang-mobile local-changer">
      <div class="flag">
        <a @click.prevent="setLocale('ger')">
          <img src="../assets/ger.webp" height="20px" width="30px" />
        </a>
      </div>
      <div class="flag">
        <a @click.prevent="setLocale('en')">
          <img src="../assets/uk.webp" height="20px" width="30px" />
        </a>
      </div>
      <div class="flag">
        <a @click.prevent="setLocale('vn')">
          <img src="../assets/vn.webp" height="20px" width="30px" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
    },
  },
};
</script>
<style lang="scss">
@import "../style/style.scss";
</style>
